// Suporta os formatos comuns de link: watch?v=, youtu.be/, embed/, shorts/.
// Usado tanto no preview do compositor (BroadcastComposeModal.vue) quanto no
// embed do modal de recebimento (App.vue).
export function parseYoutubeId(url: string): string | null {
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/)
  return m ? m[1] : null
}
